<template>
  <div class="category-wrapper pa-3">
    
    <!-- ========================================== -->
    <!-- 1. هدر و اسلایدر دسته‌های اصلی -->
    <!-- ========================================== -->
    <div class="d-flex justify-space-between align-center mb-2 px-1">
      <div class="d-flex align-center">
        <div class="title-indicator"></div>
        <span class="text-subtitle-2 font-weight-black grey--text text--darken-3 section-title">دسته‌بندی‌ها</span>
      </div>
      <v-btn text small color="primary" class="font-weight-bold rounded-lg px-2" @click="showAllCategoriesModal = true">
        مشاهده همه <v-icon small left>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <!-- افزایش فاصله بین اسلایدها به 16 -->
    <swiper-wrapper 
      v-if="rerender" 
      ref="swiper" 
      :loop="false" 
      slides-per-view="auto" 
      :space-between="16" 
      class="mb-6 pt-4 pb-6" 
      swipe-to 
      wrapper-class="category-slider"
    >
      <div 
        v-for="(item, i) in items" 
        :key="i" 
        :class="{'active-cat' : computedValue === i}"
        class="swiper-slide text-center cat-slide" 
        @click="selectCategory(i)"
      >
        <div class="card-container mx-auto">
          <v-card class="d-flex align-center flex-column justify-center category-card pa-2 mx-auto" elevation="0">
            <v-img v-if="!!item.picture" :src="item.picture" aspect-ratio="1" width="100%" height="100%" style="object-fit: contain; border-radius: inherit;"/>
            <v-icon v-else class="cat-icon" :color="computedValue === i ? 'primary' : 'grey lighten-1'">mdi-view-grid-outline</v-icon>
          </v-card>
        </div>
        <span class="mt-3 d-block text-truncate cat-text font-weight-medium">{{ item.name }}</span>
      </div>
    </swiper-wrapper>

    <!-- ========================================== -->
    <!-- 2. هدر و اسلایدر زیر دسته‌ها -->
    <!-- ========================================== -->
    <div v-if="getSubs && getSubs.length" class="sub-category-section py-2 rounded-xl">
      <div class="d-flex justify-space-between align-center mb-2 px-1">
        <div class="d-flex align-center">
          <div class="title-indicator sub-indicator"></div>
          <span class="text-subtitle-2 font-weight-black grey--text text--darken-3 section-title">زیردسته‌ها</span>
        </div>
        <v-btn text small color="primary" class="font-weight-bold rounded-lg px-2" @click="showAllSubCategoriesModal = true">
           مشاهده همه <v-icon small left>mdi-chevron-left</v-icon>
        </v-btn>
      </div>

      <!-- افزایش فاصله بین اسلایدهای زیردسته -->
      <swiper-wrapper 
        :loop="false" 
        :space-between="16" 
        slides-per-view="auto" 
        class="pt-4 pb-6"
        wrapper-class="category-slider px-1"
      swipe-to 

      >
        <div 
          v-for="(item, i) in getSubs" 
          :key="i"
          class="swiper-slide text-center cursor-pointer sub-cat-slide" 
          :class="{'active-sub-cat' : computedFilters.sub === item.id}"
          @click="selectSubCategory(item.id)"
        >
          <div class="card-container mx-auto">
            <v-card class="d-flex align-center flex-column justify-center sub-category-card pa-2 mx-auto" elevation="0">
              <v-img v-if="!!item.picture" :src="item.picture" aspect-ratio="1" width="100%" height="100%" style="object-fit: contain; border-radius: inherit;"/>
              <v-icon v-else class="sub-cat-icon" :color="computedFilters.sub === item.id ? 'primary' : 'grey lighten-1'">mdi-layers-outline</v-icon>
            </v-card>
          </div>
          <span class="mt-2 d-block text-truncate cat-text sub-cat-text">{{ item.name }}</span>
        </div>
      </swiper-wrapper>
    </div>

    <!-- بخش مودال‌ها در اینجا بدون تغییر باقی می‌ماند (برای کوتاه شدن کد حذف کردم اما شما کدهای مودال را نگه دارید) -->
    
  </div>
</template>

<script>
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper";

export default {
  name: "mCategoryView",
  components: { SwiperWrapper },
  props: { value: Number, items: Array, frontColor: String, filters: Object },
  data: () => ({ rerender: true, showAllCategoriesModal: false, showAllSubCategoriesModal: false }),
  computed: {
    computedValue: { get() { return this.value; }, set(val) { this.$emit('input', val); } },
    computedFilters: { get() { return this.filters; }, set(val) { this.$emit('update:filters', val); } },
    getSubs() {
      if (this.computedValue === null || this.computedValue === undefined) return [];
      return this.items[this.computedValue]?.subCategories || this.items[this.computedValue]?.children || [];
    }
  },
  watch: {
    items: { deep: true, handler() { this.rerenderSwiper(); } },
    showAllCategoriesModal(isOpen) { this.$root.$emit("sheet-state-change", isOpen); },
    showAllSubCategoriesModal(isOpen) { this.$root.$emit("sheet-state-change", isOpen); }
  },
  methods: {
    rerenderSwiper() { this.rerender = false; this.$nextTick(() => { this.rerender = true; }); },
    selectCategory(index) { this.computedValue = index; this.computedFilters.sub = null; if (this.$refs.swiper) this.$refs.swiper.getSwiper(); },
    selectSubCategory(id) { this.computedFilters.sub = this.computedFilters.sub === id ? null : id; }
  }
}
</script>

<style scoped>
.category-wrapper { background-color: transparent; }
.title-indicator { width: 5px; height: 18px; background: var(--v-primary-base, #0d8ddc); border-radius: 4px; margin-left: 8px; }
.sub-indicator { background: #ff9800; height: 16px; }

/* ======================================================== */
/* استایل‌های پایه و موبایل (Mobile First)                  */
/* ======================================================== */
/* عرض اسلاید بیشتر از کارت در نظر گرفته شده تا زمان بزرگ شدن روی هم نیفتند */
.cat-slide { width: 75px !important; user-select: none; cursor: pointer; }
.sub-cat-slide { width: 125px !important; user-select: none; cursor: pointer; }

.category-card {
  width: 96px !important;
  height: 96px !important;
  border-radius: 18px !important;
  background-color: #f4f6f8 !important;
  border: 1.5px solid #e5e9ec !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.sub-category-card {
  width: 66px !important;
  height: 66px !important;
  border-radius: 16px !important;
  background-color: #ffffff !important;
  border: 1.5px solid #e5e9ec !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.cat-icon { font-size: 28px !important; }
.sub-cat-icon { font-size: 24px !important; }

.cat-text { font-size: 11px; color: #546e7a; transition: all 0.3s ease; line-height: 1.4; }
.sub-cat-text { font-size: 10px; }
.section-title { font-size: 14px !important; }

/* افکت‌های هاور و انتخاب (Mobile) */
.active-cat .category-card {
  border: 2px solid var(--v-primary-base, #0d8ddc) !important;
  background-color: rgba(13, 141, 220, 0.05) !important;
  transform: scale(1.15) translateY(-4px); 
  box-shadow: 0 8px 16px rgba(13, 141, 220, 0.15) !important;
}
.active-cat .cat-text { color: var(--v-primary-base, #0d8ddc) !important; font-weight: 900 !important; transform: translateY(2px); }

.active-sub-cat .sub-category-card {
  border: 2px solid var(--v-primary-base, #0d8ddc) !important;
  background-color: rgba(13, 141, 220, 0.05) !important;
  transform: scale(1.12) translateY(-3px);
  box-shadow: 0 6px 12px rgba(13, 141, 220, 0.12) !important;
}
.active-sub-cat .cat-text { color: var(--v-primary-base, #0d8ddc) !important; font-weight: 800 !important; transform: translateY(1px); }


/* ======================================================== */
/* استایل‌های دسکتاپ و تبلت‌های بزرگ (Desktop & Large Tablet) */
/* ======================================================== */
@media (min-width: 768px) {
  /* عرض کانتینر اسلایدها در دسکتاپ */
  .cat-slide { width: 110px !important; }
  .sub-cat-slide { width: 110px !important; }

  /* ابعاد کارت‌ها در دسکتاپ */
  .category-card {
    width: 80px !important;
    height: 80px !important;
    border-radius: 24px !important;
  }
  .sub-category-card {
    width: 56px !important;
    height: 56px !important;
    border-radius: 20px !important;
  }

  /* سایز آیکون‌ها و فونت‌ها در دسکتاپ */
  .cat-icon { font-size: 38px !important; }
  .sub-cat-icon { font-size: 32px !important; }
  
  .cat-text { font-size: 14px; }
  .sub-cat-text { font-size: 13px; }
  .section-title { font-size: 16px !important; }

  /* تنظیمات انیمیشن اختصاصی دسکتاپ (سایه و پرش بیشتر) */
  .active-cat .category-card {
    transform: scale(1.15) translateY(-6px); 
    box-shadow: 0 12px 24px rgba(13, 141, 220, 0.18) !important;
  }
  .active-sub-cat .sub-category-card {
    transform: scale(1.12) translateY(-5px);
    box-shadow: 0 8px 18px rgba(13, 141, 220, 0.15) !important;
  }
}
</style>
